import { createContext, PropsWithChildren } from 'react';

// Simplified SessionProvider for build compatibility
interface SessionContextType {
  sessionId?: string;
  sendMessage?: (message: string) => void;
  chatHistory?: any[];
  currentResponse?: any;
  isTyping?: boolean;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export function SessionProvider({ 
  children, 
  botName 
}: PropsWithChildren & { botName?: string }) {
  const contextValue: SessionContextType = {
    sessionId: 'placeholder',
    sendMessage: (message: string) => window.dev?.i('Send message:', message),
    chatHistory: [],
    currentResponse: null,
    isTyping: false,
  };
  
  return (
    <SessionContext.Provider value={contextValue}>
      {children}
    </SessionContext.Provider>
  );
}

export default SessionProvider;
